import { Button } from "@mui/material";
import "./button.scss";

const AtomButton = ({
  disable = false,
  type = "button",
  onClick,
  color,
  variant = "text",
  size = "small",
  name,
  fullWidth = false,
  startIcon,
  endIcon,
  className,
  children,
  margin

}) => {
  const handleAtomButtonClick = () => {
    if (!disable && onClick) {
      onClick();
    }
  };
  return (
    <Button
      disabled={disable}
      type={type}
      onClick={handleAtomButtonClick}
      color={color}
      variant={variant}
      size={size}
      name={name}
      fullWidth={fullWidth}
      startIcon={startIcon}
      endIcon={endIcon}
      className={className}
       sx={{
    ...margin,
    // width: {
    //   xs: "100%",   // mobile (max-width: 599px)
    //   sm: "auto",
    //   md: "auto"    // above 600px
    // }
  }}
    >
      {children}
    </Button>
  );
};

export default AtomButton;
